export default "__VITE_ASSET__f927f178__"